import { CommonModule, NgIf } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AccountSharedModule, PipesModule } from 'apps/account/src/account-shared';
import { ClickOutsideModule } from 'ng-click-outside';
import { MonthlyCalendarDayComponent } from './components/monthly-calendar-day/monthly-calendar-day.component';
import { MonthlyCalendarMonthComponent } from './components/monthly-calendar-month/monthly-calendar-month.component';
import { MonthlyCalendarComponent } from './components/monthly-calendar/monthly-calendar.component';

@NgModule({
    declarations: [MonthlyCalendarComponent, MonthlyCalendarMonthComponent, MonthlyCalendarDayComponent],
    imports: [
        CommonModule,
        NgbDatepickerModule,
        PipesModule,
        NgIf,
        TranslateModule,
        AccountSharedModule,
        ClickOutsideModule,
    ],
    exports: [MonthlyCalendarComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MonthlyCalendarModule {}
